import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="kingster-footer-wrapper">
        <div className="kingster-footer-container kingster-container clearfix">
          
          <div className="kingster-footer-column kingster-item-pdlr kingster-column-15">
            <div className="widget widget_text kingster-widget">
              <div className="textwidget">
                <p>
                  <img src="/images/footer-logo.png" alt="Logo" />
                  <br />
                </p>
                <p>Immaculate School of Health Science</p>
                <p>
                  Phone: 8148037301 / 9791466774 / 8438582522 / 8098886336 / 9345898978
                  <br />
                  <a href="mailto:immaculatekkl@gmail.com">Email: immaculatekkl@gmail.com</a>
                </p>
              </div>
            </div>
          </div>
          
          <div className="kingster-footer-column kingster-item-pdlr kingster-column-15">
            <div className="widget widget_gdlr-core-custom-menu-widget kingster-widget">
              <h3 className="kingster-widget-title">Our Campus</h3>
              <ul className="gdlr-core-custom-menu-widget gdlr-core-menu-style-plain">
                <li>Idhaya Nagar,</li>
                <li>Melaputhamangalam,</li>
                <li>Thirunallar,</li>
                <li>Karaikal 609 607,</li>
                <li>Puducherry State.</li>
              </ul>
            </div>
          </div>
          
          <div className="kingster-footer-column kingster-item-pdlr kingster-column-15">
            <div className="widget widget_gdlr-core-custom-menu-widget kingster-widget">
              <h3 className="kingster-widget-title">Downloads</h3>
              <ul className="gdlr-core-custom-menu-widget gdlr-core-menu-style-plain">
                <li><a href="#">Collage Prospects</a></li>
                <li><a href="#">Application Form</a></li>
                <li><a href="#">DGNM (General Nursing & Midwifery Course)</a></li>
              </ul>
            </div>
          </div>
          
          <div className="kingster-footer-column kingster-item-pdlr kingster-column-15">
            <div className="widget widget_gdlr-core-custom-menu-widget kingster-widget">
              <h3 className="kingster-widget-title">Location</h3>
              <div className="maps-location">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.454787488807!2d79.80707361533472!3d10.92897785934652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5516c225defdc9%3A0x1fd928e561448220!2sImmaculate%20Institute%20Of%20Health%20Science!5e0!3m2!1sen!2sin!4v1596448704317!5m2!1sen!2sin"
                  width="600"
                  height="250"
                  frameBorder="0"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  aria-hidden="false"
                  tabIndex="0"
                  title="Campus Location"
                ></iframe>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="kingster-copyright-wrapper">
        <div className="kingster-copyright-container kingster-container clearfix">
          <div className="kingster-copyright-left kingster-item-pdlr">
            Copyright All Right Reserved 2025, Immaculate School of Health Science
          </div>
          <div className="kingster-copyright-right kingster-item-pdlr">
            <div className="gdlr-core-social-network-item gdlr-core-item-pdb gdlr-core-none-align">
              <a href="#" target="_blank" rel="noopener noreferrer" title="facebook"><i className="fa fa-facebook"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer" title="google-plus"><i className="fa fa-google-plus"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer" title="linkedin"><i className="fa fa-linkedin"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer" title="skype"><i className="fa fa-skype"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer" title="twitter"><i className="fa fa-twitter"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer" title="instagram"><i className="fa fa-instagram"></i></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
